import { defineMessages } from 'react-intl';

export default defineMessages({
  expand: 'Expand',
  minimize: 'Minimize',
});
